import {charcoal} from '../sass/base/_exports.sass';

/* eslint-disable camelcase */
export const MailIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 24;
  const height = 24;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 6.66782C22 5.56782 21.1 4.66782 20 4.66782H4C2.9 4.66782 2 5.56782 2 6.66782V18.6678C2 19.7678 2.9 20.6678 4 20.6678H20C21.1 20.6678 22 19.7678 22 18.6678V6.66782ZM20 6.66782L12 11.6678L4 6.66782H20ZM20 18.6678H4V8.66782L12 13.6678L20 8.66782V18.6678Z"
        fill={color}
      />
    </svg>
  );
};
